export default __webpack_public_path__ + "static/media/geometry-artwork-11.eb636aa4.jpg";